<template>
  <div id="divSummary">
    <div class="Flex_Table tblEntryForm" style="margin: 10px">
      <div class="Flex_Row">
        <div class="Flex_Cell_Inline">
          <span
            :class="TabBanner ? 'tabSelectClass' : 'tabClass'"
            v-on:click="tabClick(1)"
            >Upload Banner</span
          >
        </div>
        <div class="Flex_Cell_Inline">
          <span
            :class="TabImage ? 'tabSelectClass' : 'tabClass'"
            v-on:click="tabClick(2)"
            >Image Gallery</span
          >
        </div>
        <div class="Flex_Cell_Inline">
          <span
            :class="TabVideo ? 'tabSelectClass' : 'tabClass'"
            v-on:click="tabClick(3)"
            >Video Gallery</span
          >
        </div>
        <div class="Flex_Cell_Inline">
          <span
            :class="TabPopUp ? 'tabSelectClass' : 'tabClass'"
            v-on:click="tabClick(4)"
            >Popup Image</span
          >
        </div>
      </div>
    </div>
    <div style="margin: 10px">
      <div class="Flex_Table" v-if="TabBanner" v-show="TabBanner">
        <fieldset style="width: 100% !important">
          <legend>Banner</legend>

          <div class="Flex_Table tblEntryForm" style="margin: 10px">
            <div class="Flex_Row">
              <div class="Flex_Cell_Inline">
                <span class="mandatorySpan" :class="{ Required: true }"
                  >Page Type</span
                >
                <select id="ddlPageType" v-model="PageType">
                  <!-- @change="getBannerList()" -->
                  <option value>---Select---</option>
                  <option value="Marvels">Marvels</option>
                  <option value="Atal Tunnel">Atal Tunnel</option>
                  <option value="Cafe">Cafe</option>
                </select>
              </div>
              <div class="Flex_Cell_Inline" width="7%">
                <span class="mandatorySpan" :class="{ Required: true }"
                  >Order By</span
                >
                <AcceptInput
                  maxlength="5"
                  type="textbox"
                  :isRequired="true"
                  placeholder="0"
                  v-model="OrderByBanner"
                  regExp="([0-9])*"
                />
              </div>
              <div class="Flex_Cell_Inline">
                <span class="mandatorySpan">Caption Header</span>
                <AcceptInput
                  maxlength="200"
                  type="textbox"
                  placeholder="Caption Header"
                  v-model="CaptionHeaderBanner"
                  regExp="([A-Z a-z()])*"
                />
              </div>
              <div class="Flex_Cell_Inline">
                <span class="mandatorySpan">Caption Text One</span>
                <AcceptInput
                  maxlength="200"
                  type="textbox"
                  placeholder="Caption Text One"
                  v-model="CaptionTextOneBanner"
                  regExp="([A-Z a-z()])*"
                />
              </div>
              <div class="Flex_Cell_Inline">
                <span class="mandatorySpan">Caption Text Two</span>
                <AcceptInput
                  maxlength="200"
                  type="textbox"
                  placeholder="Caption Text Two"
                  v-model="CaptionTextTwoBanner"
                  regExp="([A-Z a-z()])*"
                />
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell_Inline">
                <span class="mandatorySpan" :class="{ Required: true }">
                  Upload Banner (File must be in .jpg /.jpeg /.png format and
                  size between 100 to 200 kb only and dimension 1920 * 1080)
                </span>
                <input
                  type="file"
                  id="FileBox"
                  v-on:change="BannerFileChosen($event)"
                />
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell_Inline">
                <input
                  type="button"
                  style="padding: 5px ; width : 100px"
                  value="Add"
                  @click="addBanner()"
                />
              </div>
              <div class="Flex_Cell_Inline">
                <input
                  type="button"
                  style="padding: 5px ; width : 100px"
                  value="Clear"
                  @click="clearBanner()"
                />
              </div>
            </div>
          </div>

          <fieldset style="width: 100% !important">
            <legend>Banner List</legend>

            <div class="Flex_Table ekkGrid">
              <div
                class="Flex_Row GridHeader"
                align="center"
                valign="middle"
                style="min-height: 40px"
              >
                <div class="Flex_Cell" width="2%">Sl.No</div>

                <div class="Flex_Cell" width="10%">Page Type</div>
                <div class="Flex_Cell" width="10%">Banner Image</div>

                <div class="Flex_Cell" width="10%">Order By</div>
                <div class="Flex_Cell" width="10%">Caption Header</div>
                <div class="Flex_Cell" width="10%">Caption Text One</div>
                <div class="Flex_Cell" width="10%">Caption Text Two</div>
                <div class="Flex_Cell" width="2%"></div>
              </div>
              <div
                class="Flex_Row GridContent"
                align="center"
                valign="middle"
                v-for="(row, index) in banner_List"
                :key="index"
              >
                <div class="Flex_Cell" width="2%">{{ index + 1 }}</div>

                <div class="Flex_Cell" width="10%">{{ row.pageType }}</div>
                <div class="Flex_Cell" width="10%">
                  <a @click="openUploadedFile(row)">
                    {{ row.bannerImageFileName }}
                  </a>
                </div>

                <div class="Flex_Cell" width="10%">{{ row.orderBy }}</div>
                <div class="Flex_Cell" width="10%">{{ row.captionHeader }}</div>
                <div class="Flex_Cell" width="10%">
                  {{ row.captionTextOne }}
                </div>
                <div class="Flex_Cell" width="10%">
                  {{ row.captionTextTwo }}
                </div>

                <div class="Flex_Cell" width="2%">
                  <span
                    class="glyphicons bin"
                    v-on:click="deleteBannerImage(row)"
                    style="cursor: pointer; color: Red"
                    title="Delete"
                  ></span>
                </div>
              </div>
            </div>
          </fieldset>
        </fieldset>
      </div>
    </div>
    <div class="Flex_Table" v-if="TabImage" v-show="TabImage">
      <fieldset style="width: 100% !important">
        <legend>Photo Gallery</legend>
        <div class="Flex_Table tblEntryForm" style="margin: 10px">
          <div class="Flex_Row">
            <div class="Flex_Cell_Inline">
              <span class="mandatorySpan" :class="{ Required: true }"
                >Photo Gallery</span
              >
              <select id="ddlPhotoGallery" v-model="PhotoGallery">
                <option value>---Select---</option>
                <option value="Valley">Valley</option>
                <option value="Tracking">Tracking</option>
                <option value="Adventure-Sports">Adventure-Sports</option>
                <option value="Holy-Places">Holy-Places</option>
              </select>
            </div>
            <div class="Flex_Cell_Inline" width="7%">
              <span class="mandatorySpan" :class="{ Required: true }"
                >Order By</span
              >
              <AcceptInput
                maxlength="5"
                type="textbox"
                :isRequired="true"
                placeholder="0"
                v-model="OrderByPhotoGallery"
                regExp="([0-9])*"
              />
            </div>
            <div class="Flex_Cell_Inline" width="30%">
              <span class="mandatorySpan">Caption</span>
              <AcceptInput
                maxlength="200"
                type="textbox"
                placeholder="Caption"
                v-model="Caption"
              />
            </div>
            <div class="Flex_Cell_Inline" width="30%">
              <span class="mandatorySpan">Details</span>
              <AcceptInput
                maxlength="200"
                type="textbox"
                placeholder="Details"
                v-model="Details"
              />
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell_Inline">
              <span class="mandatorySpan" :class="{ Required: true }">
                Upload Photo Gallery (File must be in .jpg /.jpeg /.png format
                and size between 50 to 150 kb only)
              </span>
              <input
                type="file"
                id="FileBox"
                v-on:change="PhotoGalleryFileChosen($event)"
              />
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell_Inline">
              <input
                type="button"
                style="padding: 5px ; width : 100px"
                value="Add"
                @click="addPhotoGallery()"
              />
            </div>
            <div class="Flex_Cell_Inline">
              <input
                type="button"
                style="padding: 5px ; width : 100px"
                value="Clear"
                @click="clearPhotoGallery()"
              />
            </div>
          </div>
        </div>

        <fieldset style="width: 100% !important">
          <legend>Photo List</legend>

          <div class="Flex_Table ekkGrid">
            <div
              class="Flex_Row GridHeader"
              align="center"
              valign="middle"
              style="min-height: 40px"
            >
              <div class="Flex_Cell" width="2%">Sl.No</div>

              <div class="Flex_Cell" width="10%">Photo Gallery</div>

              <div class="Flex_Cell" width="10%">Photo Gallery Image</div>

              <div class="Flex_Cell" width="10%">Order By</div>
              <div class="Flex_Cell" width="10%">Caption</div>
              <div class="Flex_Cell" width="10%">Details</div>

              <div class="Flex_Cell" width="2%"></div>
            </div>
            <div
              class="Flex_Row GridContent"
              align="center"
              valign="middle"
              v-for="(row, index) in photoGallery_List"
              :key="index"
            >
              <div class="Flex_Cell" width="2%">{{ index + 1 }}</div>

              <div class="Flex_Cell" width="10%">{{ row.photoGallery }}</div>
              <div class="Flex_Cell" width="10%">
                <a @click="openUploadedFilePhotoGallery(row)">
                  {{ row.photoGalleryImageFileName }}
                </a>
              </div>

              <div class="Flex_Cell" width="10%">{{ row.orderBy }}</div>
              <div class="Flex_Cell" width="10%">{{ row.caption }}</div>
              <div class="Flex_Cell" width="10%">{{ row.details }}</div>

              <div class="Flex_Cell" width="2%">
                <span
                  class="glyphicons bin"
                  v-on:click="deletePhotoGalleryImage(row)"
                  style="cursor: pointer; color: Red"
                  title="Delete"
                ></span>
              </div>
            </div>
          </div>
        </fieldset>
      </fieldset>
    </div>
    <div class="Flex_Table" v-if="TabVideo" v-show="TabVideo">
      <fieldset style="width: 100% !important">
        <legend>Video Gallery</legend>
        <div class="Flex_Table tblEntryForm" style="margin: 10px">
          <div class="Flex_Row">
            <div class="Flex_Cell_Inline">
              <span class="mandatorySpan" :class="{ Required: true }"
                >Gallery Name</span
              >
              <select id="ddlGalleryName" v-model="GalleryName">
                <option value>---Select---</option>
                <option value="Valley">Valley</option>
                <option value="Tracking">Tracking</option>
                <option value="Adventure-Sports">Adventure-Sports</option>
                <option value="Holy-Places">Holy-Places</option>
              </select>
            </div>

            <div class="Flex_Cell_Inline" width="8%">
              <span class="mandatorySpan" :class="{ Required: true }"
                >Order By</span
              >
              <AcceptInput
                maxlength="5"
                type="textbox"
                :isRequired="true"
                placeholder="0"
                v-model="OrderByVideoGallery"
                regExp="([0-9])*"
              />
            </div>
            <div class="Flex_Cell_Inline">
              <span class="mandatorySpan" :class="{ Required: true }"
                >YouTube VideoId</span
              >
              <AcceptInput
                maxlength="20"
                type="textbox"
                placeholder="YouTube VideoId"
                v-model="YouTubeVideoId"
              />
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell_Inline">
              <input
                type="button"
                style="padding: 5px ; width : 100px"
                value="Add"
                @click="addVideoGallery()"
              />
            </div>
            <div class="Flex_Cell_Inline">
              <input
                type="button"
                style="padding:5px; width:100px;"
                value="Clear"
                @click="clearVideoGallery()"
              />
            </div>
          </div>
        </div>

        <fieldset style="width: 100% !important">
          <legend>Video List</legend>

          <div class="Flex_Table ekkGrid">
            <div
              class="Flex_Row GridHeader"
              align="center"
              valign="middle"
              style="min-height: 40px"
            >
              <div class="Flex_Cell" width="2%">Sl.No</div>

              <div class="Flex_Cell" width="10%">Gallery Name</div>
              <div class="Flex_Cell" width="10%">YouTube VideoID</div>

              <div class="Flex_Cell" width="10%">Order By</div>
              <div class="Flex_Cell" width="2%"></div>
            </div>
            <div
              class="Flex_Row GridContent"
              align="center"
              valign="middle"
              v-for="(row, index) in videoGallery_List"
              :key="index"
            >
              <div class="Flex_Cell" width="2%">{{ index + 1 }}</div>

              <div class="Flex_Cell" width="10%">{{ row.galleryName }}</div>
              <div class="Flex_Cell" width="10%">{{ row.youTubeVideoId }}</div>
              <div class="Flex_Cell" width="10%">{{ row.orderBy }}</div>
              <div class="Flex_Cell" width="2%">
                <span
                  class="glyphicons bin"
                  v-on:click="deleteVideoGallery(row)"
                  style="cursor: pointer; color: Red"
                  title="Delete"
                ></span>
              </div>
            </div>
          </div>
        </fieldset>
      </fieldset>
    </div>
    <div class="Flex_Table" v-if="TabPopUp" v-show="TabPopUp">
      <fieldset style="width: 100% !important">
        <legend>PopUp Image</legend>
        <div class="Flex_Table tblEntryForm" style="margin: 10px">
          <div class="Flex_Row">
            <div class="Flex_Cell_Inline">
              <span class="mandatorySpan" :class="{ Required: true }"
                >Page Name</span
              >
              <select id="ddlPageName" v-model="PageName" required="required">
                <option value>---Select---</option>
                <option value="Marvels">Marvels</option>
                <option value="Atal Tunnel">Atal Tunnel</option>
              </select>
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell_Inline">
              <span class="mandatorySpan" :class="{ Required: true }">
                Upload Banner (File must be in .jpg /.jpeg /.png format and size
                between 50 to 150 kb only)
              </span>
              <input
                type="file"
                id="FileBox"
                v-on:change="PopupFileChosen($event)"
              />
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell_Inline">
              <input
                type="button"
                style="padding: 5px ; width : 100px"
                value="Add"
                @click="addPopupImage()"
              />
            </div>
            <div class="Flex_Cell_Inline">
              <input
                type="button"
                style="padding:5px; width:100px;"
                value="Clear"
                @click="clearPopupImage()"
              />
            </div>
          </div>
        </div>

        <fieldset style="width: 100% !important">
          <legend>PopUp Image List</legend>

          <div class="Flex_Table ekkGrid">
            <div
              class="Flex_Row GridHeader"
              align="center"
              valign="middle"
              style="min-height: 40px"
            >
              <div class="Flex_Cell" width="2%">Sl.No</div>

              <div class="Flex_Cell" width="10%">Page Name</div>
              <div class="Flex_Cell" width="10%">PopUp Image</div>
              <div class="Flex_Cell" width="2%"></div>
            </div>
            <div
              class="Flex_Row GridContent"
              align="center"
              valign="middle"
              v-for="(row, index) in popupImage_List"
              :key="index"
            >
              <div class="Flex_Cell" width="2%">{{ index + 1 }}</div>

              <div class="Flex_Cell" width="10%">{{ row.pageName }}</div>
              <div class="Flex_Cell" width="10%">
                <a @click="openUploadedFilePopUp(row)">{{
                  row.popUpImageFileName
                }}</a>
              </div>
              <div class="Flex_Cell" width="2%">
                <span
                  class="glyphicons bin"
                  v-on:click="deletePopupImage(row)"
                  style="cursor: pointer; color: Red"
                  title="Delete"
                ></span>
              </div>
            </div>
          </div>
        </fieldset>
      </fieldset>
    </div>
  </div>
</template>

<script>
import AcceptInput from "./ekkControls/AcceptInput";
import DateControl from "./ekkControls/DateControl";
import MasterEntryJS from "./servicesJS/MasterEntry.js";
import MasterJS from "./servicesJS/Master.js";
import CmsJS from "./servicesJS/CMS.js";

export default {
  name: "CMS",
  components: {
    DateControl: DateControl,
    AcceptInput: AcceptInput
  },
  data() {
    return {
      TabBanner: true,
      TabImage: false,
      TabVideo: false,
      TabPopUp: false,
      PageType: "",
      OrderByBanner: 0,
      CaptionHeaderBanner: "",
      CaptionTextOneBanner: "",
      CaptionTextTwoBanner: "",
      OrderByPhotoGallery: 0,
      PhotoGallery: "",
      Caption: "",
      Details: "",
      uploadedImg: [],
      uploadedPhotoGalleryImg: [],
      uploadedPopUpImg: [],
      banner_List: [],
      photoGallery_List: [],
      OrderByVideoGallery: 0,
      videoGallery_List: [],
      GalleryName: "",
      YouTubeVideoId: "",
      PageName: "",
      PopUpImage: "",
      popupImage_List: []
    };
  },
  methods: {
    tabClick(type) {
      this.TabBanner = false;
      this.TabImage = false;
      this.TabVideo = false;
      this.TabPopUp = false;
      if (type == 1) {
        this.TabBanner = true;
        this.getBanner();
      } else if (type == 2) {
        this.TabImage = true;
        this.getPhotoGallery();
      } else if (type == 3) {
        this.TabVideo = true;
        this.getVideoGallery();
      } else {
        this.TabPopUp = true;
        this.getPopupImage();
      }
    },
    clearBanner() {
      this.PageType = "";
      this.OrderByBanner = 0;
      this.CaptionHeaderBanner = "";
      this.CaptionTextOneBanner = "";
      this.CaptionTextTwoBanner = "";
      $("#FileBox").val("");
    },
    clearPhotoGallery() {
      this.PhotoGallery = "";
      this.Caption = "";
      this.Details = "";
      this.OrderByPhotoGallery = 0;
      $("#FileBox").val("");
    },
    clearVideoGallery() {
      this.GalleryName = "";
      this.YouTubeVideoId = "";
      this.OrderByVideoGallery = 0;
    },
    clearPopupImage() {
      this.PageName = "";
      $("#FileBox").val("");
    },
    BannerFileChosen(evnt) {
      this.getFileData(evnt);
    },
    getFileData(event) {
      var ext = ["JPG", "JPEG", "PNG"];
      var me = this;
      var myFiles = [];

      var lstFiles = event.target.files;
      var isValidExtension = true;
      var isValidSize = true;
      var isMinValidSize = true;
      var minCheckSize = parseFloat(100 * 1024);
      var maxcheckSize = parseFloat(200 * 1024);

      for (var i = 0; i < lstFiles.length; i++) {
        var fName = lstFiles[i].name;
        var fileExt = fName.split(".").pop();
        if (!(ext.indexOf(fileExt.toUpperCase()) >= 0)) {
          isValidExtension = false;
        }
        var size = lstFiles[i].size;
        if (parseFloat(size) < minCheckSize) {
          isMinValidSize = false;
        }
        if (parseFloat(size) > maxcheckSize) {
          isValidSize = false;
        }
        myFiles.push(lstFiles[i]);
      }

      if (isValidExtension == false) {
        alert("Unsupported media type.");
        event.target.value = "";
        return false;
      }
      if (isMinValidSize == false) {
        alert(
          "Individual files minimum size should be more than " +
            parseFloat(minCheckSize) / 1024 +
            " KB"
        );
        event.target.value = "";
        return false;
      }
      if (isValidSize == false) {
        alert(
          "Individual files size should be less than " +
            parseFloat(maxcheckSize) / 1024 +
            " KB."
        );
        event.target.value = "";
        return false;
      }
      myFiles.forEach(element => {
        var fName = element.name;
        var fileExt = fName.split(".").pop();
        var reader = new FileReader();
        reader.addEventListener("load", function(e) {
          var object = new Object();
          object.filePreview = e.target.result.split(",")[1];
          object.docFileName = fName;
          object.ext = fileExt;
          me.uploadedImg.push(object);
        });

        if (ext.indexOf(fileExt.toUpperCase()) >= 0) {
          reader.readAsDataURL(element);
        }
      });
    },
    getFileDataGalleryImage(event) {
      var ext = ["JPG", "JPEG", "PNG"];
      var me = this;
      var myFiles = [];

      var lstFiles = event.target.files;
      var isValidExtension = true;
      var isValidSize = true;
      var isMinValidSize = true;
      var minCheckSize = parseFloat(50 * 1024);
      var maxcheckSize = parseFloat(150 * 1024);

      for (var i = 0; i < lstFiles.length; i++) {
        var fName = lstFiles[i].name;
        var fileExt = fName.split(".").pop();
        if (!(ext.indexOf(fileExt.toUpperCase()) >= 0)) {
          isValidExtension = false;
        }
        var size = lstFiles[i].size;
        if (parseFloat(size) < minCheckSize) {
          isMinValidSize = false;
        }
        if (parseFloat(size) > maxcheckSize) {
          isValidSize = false;
        }
        myFiles.push(lstFiles[i]);
      }

      if (isValidExtension == false) {
        alert("Unsupported media type.");
        event.target.value = "";
        return false;
      }
      if (isMinValidSize == false) {
        alert(
          "Individual files minimum size should be more than " +
            parseFloat(minCheckSize) / 1024 +
            " KB"
        );
        event.target.value = "";
        return false;
      }
      if (isValidSize == false) {
        alert(
          "Individual files size should be less than " +
            parseFloat(maxcheckSize) / 1024 +
            " KB."
        );
        event.target.value = "";
        return false;
      }
      myFiles.forEach(element => {
        var fName = element.name;
        var fileExt = fName.split(".").pop();
        var reader = new FileReader();
        reader.addEventListener("load", function(e) {
          var object = new Object();
          object.filePreview = e.target.result.split(",")[1];
          object.docFileName = fName;
          object.ext = fileExt;
          me.uploadedPhotoGalleryImg.push(object);
        });

        if (ext.indexOf(fileExt.toUpperCase()) >= 0) {
          reader.readAsDataURL(element);
        }
      });
    },
    getFileDataPopUpImage(event) {
      var ext = ["JPG", "JPEG", "PNG"];
      var me = this;
      var myFiles = [];

      var lstFiles = event.target.files;
      var isValidExtension = true;
      var isValidSize = true;
      var isMinValidSize = true;
      var minCheckSize = parseFloat(50 * 1024);
      var maxcheckSize = parseFloat(150 * 1024);

      for (var i = 0; i < lstFiles.length; i++) {
        var fName = lstFiles[i].name;
        var fileExt = fName.split(".").pop();
        if (!(ext.indexOf(fileExt.toUpperCase()) >= 0)) {
          isValidExtension = false;
        }
        var size = lstFiles[i].size;
        if (parseFloat(size) < minCheckSize) {
          isMinValidSize = false;
        }
        if (parseFloat(size) > maxcheckSize) {
          isValidSize = false;
        }
        myFiles.push(lstFiles[i]);
      }

      if (isValidExtension == false) {
        alert("Unsupported media type.");
        event.target.value = "";
        return false;
      }
      if (isMinValidSize == false) {
        alert(
          "Individual files minimum size should be more than " +
            parseFloat(minCheckSize) / 1024 +
            " KB"
        );
        event.target.value = "";
        return false;
      }
      if (isValidSize == false) {
        alert(
          "Individual files size should be less than " +
            parseFloat(maxcheckSize) / 1024 +
            " KB."
        );
        event.target.value = "";
        return false;
      }
      myFiles.forEach(element => {
        var fName = element.name;
        var fileExt = fName.split(".").pop();
        var reader = new FileReader();
        reader.addEventListener("load", function(e) {
          var object = new Object();
          object.filePreview = e.target.result.split(",")[1];
          object.docFileName = fName;
          object.ext = fileExt;
          me.uploadedPopUpImg.push(object);
        });

        if (ext.indexOf(fileExt.toUpperCase()) >= 0) {
          reader.readAsDataURL(element);
        }
      });
    },
    addBanner() {
      var msg = "";
      if (this.PageType == "") {
        msg = "Please Select Page Type";
      } else if (this.OrderByBanner == 0) {
        msg = "Please Enter Order By";
      } else if (this.uploadedImg == null || this.uploadedImg.length == 0) {
        msg = "Please upload image";
      }
      if (msg != "") {
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Error"
        });
        return;
      }
      var basicData = {
        BannerImageId: -1,
        PageType: this.PageType,
        BannerImage: this.uploadedImg[0].filePreview,
        BannerImageFileName: this.uploadedImg[0].docFileName,
        BannerImageExtension: this.uploadedImg[0].ext,
        OrderBy: this.OrderByBanner,
        CaptionHeader: this.CaptionHeaderBanner,
        CaptionTextOne: this.CaptionTextOneBanner,
        CaptionTextTwo: this.CaptionTextTwoBanner
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      CmsJS.SetBannerImage(formData).then(
        response => {
          var msg = response.data.msg;
          var isSuccess = response.data.isSuccess;
          if (isSuccess) {
            this.uploadedImg = [];
            this.PageType = "";
            this.getBanner();
            this.clearBanner();
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success"
            });
          } else {
            MessageBox.show({
              message: "Something went wrong...",
              type: "error",
              title: "Error"
            });
          }
        },
        error => {}
      );
    },
    getBanner() {
      this.banner_List = [];
      const _data_ = { PageType: this.PageType };
      // console.log(_data_);
      CmsJS.GetBannerImage(_data_).then(
        response => {
          this.banner_List = response.data;
          // console.log(this.banner_List);
        },
        error => {}
      );
    },
    openUploadedFile(row) {
      //var fileExt = row.idImageFileExtension;
      var img = new Image();
      let imgURL;
      {
        this.windowPreview;
        if (this.windowPreview != null) {
          this.windowPreview.close();
        }
        this.windowPreview = window.open(
          "",
          "FilePreview",
          "scrollbars,addressbar=no,location=no,resizable=yes,width=950px,height=600px,left=10,top=10"
        );
        imgURL = "data:image/jpeg;base64," + row.bannerImage;

        img.src = imgURL;
        this.windowPreview.document.write(img.outerHTML);
      }
    },
    openUploadedFilePhotoGallery(row) {
      //var fileExt = row.idImageFileExtension;
      var img = new Image();
      let imgURL;
      {
        this.windowPreview;
        if (this.windowPreview != null) {
          this.windowPreview.close();
        }
        this.windowPreview = window.open(
          "",
          "FilePreview",
          "scrollbars,addressbar=no,location=no,resizable=yes,width=950px,height=600px,left=10,top=10"
        );
        imgURL = "data:image/jpeg;base64," + row.photoGalleryImage;

        img.src = imgURL;
        this.windowPreview.document.write(img.outerHTML);
      }
    },
    openUploadedFilePopUp(row) {
      //var fileExt = row.idImageFileExtension;
      var img = new Image();
      let imgURL;
      {
        this.windowPreview;
        if (this.windowPreview != null) {
          this.windowPreview.close();
        }
        this.windowPreview = window.open(
          "",
          "FilePreview",
          "scrollbars,addressbar=no,location=no,resizable=yes,width=950px,height=600px,left=10,top=10"
        );
        imgURL = "data:image/jpeg;base64," + row.popUpImage;

        img.src = imgURL;
        this.windowPreview.document.write(img.outerHTML);
      }
    },
    deleteBannerImage(r) {
      var basicData = {
        BannerImageId: r.bannerImageId,
        PageType: "",
        BannerImage: "",
        BannerImageFileName: "",
        BannerImageExtension: "",
        OrderBy: 0,
        CaptionHeader: "",
        CaptionTextOne: "",
        CaptionTextTwo: ""
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      CmsJS.DeleteBannerImage(formData).then(
        response => {
          var msg = response.data.msg;
          var isSuccess = response.data.isSuccess;
          if (isSuccess) {
            this.getBanner();
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success"
            });
          } else {
            MessageBox.show({
              message: "Something went wrong...",
              type: "error",
              title: "Error"
            });
          }
        },
        error => {}
      );
    },
    PhotoGalleryFileChosen(evnt) {
      this.getFileDataGalleryImage(evnt);
    },
    addPhotoGallery() {
      var msg = "";
      if (this.PhotoGallery == "") {
        msg = "Please Select Photo Gallery";
      } else if (this.OrderByPhotoGallery == 0) {
        msg = "Please Enter OrderBy";
      } else if (
        this.uploadedPhotoGalleryImg == null ||
        this.uploadedPhotoGalleryImg.length == 0
      ) {
        msg = "Please upload image";
      }
      if (msg != "") {
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Error"
        });
        return;
      }
      var basicData = {
        PhotoGalleryImageId: -1,
        PhotoGallery: this.PhotoGallery,
        PhotoGalleryImage: this.uploadedPhotoGalleryImg[0].filePreview,
        PhotoGalleryImageFileName: this.uploadedPhotoGalleryImg[0].docFileName,
        PhotoGalleryImageExtension: this.uploadedPhotoGalleryImg[0].ext,
        OrderBy: this.OrderByPhotoGallery,
        Caption: this.Caption,
        Details: this.Details
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      CmsJS.SetPhotoGallery(formData).then(
        response => {
          var msg = response.data.msg;
          var isSuccess = response.data.isSuccess;
          if (isSuccess) {
            this.uploadedPhotoGalleryImg = [];
            this.PhotoGallery = "";
            this.getPhotoGallery();
            this.clearPhotoGallery();
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success"
            });
          } else {
            MessageBox.show({
              message: "Something went wrong...",
              type: "error",
              title: "Error"
            });
          }
        },
        error => {}
      );
    },
    getPhotoGallery() {
      this.photoGallery_List = [];
      const _data_ = { PhotoGallery: this.PhotoGallery };
      // console.log(_data_);
      CmsJS.GetPhotoGallery(_data_).then(
        response => {
          this.photoGallery_List = response.data;
          // console.log(this.photoGallery_List);
        },
        error => {}
      );
    },
    deletePhotoGalleryImage(r) {
      var basicData = {
        PhotoGalleryImageId: r.photoGalleryImageId,
        PhotoGallery: "",
        PhotoGalleryImage: "",
        PhotoGalleryImageFileName: "",
        PhotoGalleryImageExtension: "",
        OrderBy: 0,
        Caption: "",
        Details: ""
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      CmsJS.deletePhotoGalleryImage(formData).then(
        response => {
          var msg = response.data.msg;
          var isSuccess = response.data.isSuccess;
          if (isSuccess) {
            this.getPhotoGallery();
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success"
            });
          } else {
            MessageBox.show({
              message: "Something went wrong...",
              type: "error",
              title: "Error"
            });
          }
        },
        error => {}
      );
    },
    addVideoGallery() {
      var msg = "";
      if (this.GalleryName == "") {
        msg = "Please Select Gallery Name";
      } else if (this.OrderByVideoGallery == 0) {
        msg = "Please Enter OrderBy";
      } else if (this.YouTubeVideoId == "") {
        msg = "Please Enter YouTube VideoId";
      }
      if (msg != "") {
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Error"
        });
        return;
      }
      var basicData = {
        VideoId: -1,
        GalleryName: this.GalleryName,
        YouTubeVideoId: this.YouTubeVideoId,
        OrderBy: this.OrderByVideoGallery
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      CmsJS.SetVideoGallery(formData).then(
        response => {
          var msg = response.data.msg;
          var isSuccess = response.data.isSuccess;
          if (isSuccess) {
            this.GalleryName = "";
            this.getVideoGallery();
            this.clearVideoGallery();
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success"
            });
          } else {
            MessageBox.show({
              message: "Something went wrong...",
              type: "error",
              title: "Error"
            });
          }
        },
        error => {}
      );
    },
    getVideoGallery() {
      this.videoGallery_List = [];
      const _data_ = { VideoGallery: this.GalleryName };
      // console.log(_data_);
      CmsJS.GetVideoGallery(_data_).then(
        response => {
          this.videoGallery_List = response.data;
          // console.log(this.videoGallery_List);
        },
        error => {}
      );
    },
    deleteVideoGallery(r) {
      var basicData = {
        VideoId: r.videoId,
        GalleryName: "",
        YouTubeVideoId: "",
        OrderBy: 0
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      CmsJS.DeleteVideoGallery(formData).then(
        response => {
          var msg = response.data.msg;
          var isSuccess = response.data.isSuccess;
          if (isSuccess) {
            this.getVideoGallery();
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success"
            });
          } else {
            MessageBox.show({
              message: "Something went wrong...",
              type: "error",
              title: "Error"
            });
          }
        },
        error => {}
      );
    },
    PopupFileChosen(evnt) {
      this.getFileDataPopUpImage(evnt);
    },
    addPopupImage() {
      var msg = "";
      if (this.PageName == "") {
        msg = "Please Select Page Name";
      } else if (
        this.uploadedPopUpImg == null ||
        this.uploadedPopUpImg.length == 0
      ) {
        msg = "Please Upload Image";
      }
      if (msg != "") {
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Error"
        });
        return;
      }
      var basicData = {
        PageId: -1,
        PageName: this.PageName,
        PopUpImage: this.uploadedPopUpImg[0].filePreview,
        PopUpImageFileName: this.uploadedPopUpImg[0].docFileName,
        PopUpImageExtension: this.uploadedPopUpImg[0].ext
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      CmsJS.setPopUpImage(formData).then(
        response => {
          var msg = response.data.msg;
          var isSuccess = response.data.isSuccess;
          if (isSuccess) {
            this.PageName = "";
            this.getPopupImage();
            this.clearPopupImage();
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success"
            });
          } else {
            MessageBox.show({
              message: "Something went wrong...",
              type: "error",
              title: "Error"
            });
          }
        },
        error => {}
      );
    },
    getPopupImage() {
      this.popupImage_List = [];
      const _data_ = { PageName: this.PageName };
      // console.log(_data_);
      CmsJS.getPopupImage(_data_).then(
        response => {
          this.popupImage_List = response.data;
          // console.log(this.popupImage_List);
        },
        error => {}
      );
    },
    deletePopupImage(r) {
      var basicData = {
        PageId: r.pageId,
        PageName: "",
        PopUpImage: "",
        PopUpImageFileName: "",
        PopUpImageExtension: ""
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      CmsJS.DeletePopupImage(formData).then(
        response => {
          var msg = response.data.msg;
          var isSuccess = response.data.isSuccess;
          if (isSuccess) {
            this.getPopupImage();
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success"
            });
          } else {
            MessageBox.show({
              message: "Something went wrong...",
              type: "error",
              title: "Error"
            });
          }
        },
        error => {}
      );
    }
  },
  mounted() {
    this.tabClick(1);
  }
};
</script>

<style scoped>
.wrapText {
  overflow-wrap: anywhere;
}
#background {
  background: url("../assets/images/logoa.png");
}
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divSummary {
  margin-left: 4px;
  margin-right: 5px;
  /* border: dotted 1px darkgray;
        border-radius: 5px;
        padding: 5px 0px 0px 5px; */
}
.ekkGrid > .Flex_Row:hover:not(.GridHeader),
.ekkGrid > .GridContent > .Flex_Row:hover:not(.GridHeader) {
  background-color: #ffa50069;
  color: black;
}
</style>
<style scoped>
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
</style>
<style scoped>
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  border: solid 1px;
  border-radius: 4px;
  top: 110px;
  position: absolute;
  min-height: 256px;
  right: 380px;
  /* background-color: ;rgba(255, 248, 248, 0.86); */
  background-color: ghostwhite;
  -webkit-box-shadow: 1px 1px 20px 1px white;
  box-shadow: 1px 1px 20px 1px white;
  border-radius: 8px 8px 8px 8px;
  z-index: 2;
  color: black !important;
  width: 600px;
}
.PopUpDetail {
  padding: 10px;
  /* min-height: 200px;
        max-height: 400px; */
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 38px;
  border-bottom: solid 1px;
  border-radius: 8px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px; */
  background-color: white;
  color: Black;
}
.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px black; */
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CMS.vue